import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PaymentSuccessComponent implements OnInit {
  seconds = 7;
  counter: number;
  constructor(public router: Router) {}

  ngOnInit(): void {
    // this.startCountdown(this.seconds);
  }

  startCountdown(seconds) {
    this.counter = seconds;

    const interval = setInterval(() => {
      this.counter--;
      if (this.counter < 1) {
        clearInterval(interval);
        this.router.navigate(['/boka']);
      }
    }, 1000);
  }
}
